var map = {
	"./001-facebook1.png": 85,
	"./003-twitter1.png": 86,
	"./004-instagram1.png": 87,
	"./AgriIndustrial.jpg": 127,
	"./BusinessLine.png": 88,
	"./Contracticonpay.png": 128,
	"./EstateLands.jpg": 76,
	"./HomePageLandServices.jpg": 77,
	"./IndiaMap.png": 129,
	"./KeeVurds.png": 89,
	"./LOGOJPEG .jpg": 90,
	"./Listing.png": 130,
	"./NewPapaGreenPumpLogo.jpg": 131,
	"./OXYLoans.jpg": 132,
	"./Sell.svg": 133,
	"./Signup.png": 134,
	"./StartupTalky.png": 91,
	"./SustainableFarms.jpg": 135,
	"./SzuperAgridigitalSolutionPvtLtd.png": 136,
	"./Visitor.png": 137,
	"./Yourstory.png": 92,
	"./agriLands.jpeg": 78,
	"./autoagronom.png": 138,
	"./bio-gas.png": 93,
	"./certificate.jpg": 139,
	"./chick.jpg": 140,
	"./chickp.png": 141,
	"./chickpn.png": 142,
	"./chickpnp.jpg": 143,
	"./chickpnpp.png": 144,
	"./collectiveFarming.jpeg": 79,
	"./cs.jpg": 54,
	"./deal1.png": 94,
	"./ecoFarms.jpeg": 145,
	"./facebook.png": 146,
	"./facebook1.png": 147,
	"./farmIndia_img_1.png": 148,
	"./farmindia_img_2.png": 149,
	"./farmindia_img_3.png": 150,
	"./farmindia_img_4.png": 151,
	"./farmindia_img_5.png": 152,
	"./farmindia_img_client_1.svg": 153,
	"./farmindia_img_client_2.svg": 154,
	"./farmindia_logo.png": 95,
	"./farmsindia_listing2.png": 96,
	"./farmsindia_location1.png": 97,
	"./farmsindia_signup3.png": 98,
	"./farmsindia_view4.png": 99,
	"./image.png": 155,
	"./instagram.png": 156,
	"./landContracts.jpeg": 80,
	"./lines_bg.jpg": 157,
	"./linkedin1.png": 158,
	"./logo.png": 159,
	"./medium.png": 160,
	"./medium1.png": 161,
	"./medium2.png": 100,
	"./newAgriLands.jpg": 162,
	"./newEcoFarms.jpg": 163,
	"./newEstateLands.jpg": 164,
	"./newSmallFarms.jpg": 165,
	"./newUpdatedAgriLands.jpg": 166,
	"./newUpdatedEcoFarms.jpg": 167,
	"./newUpdatedEstateLands.jpg": 168,
	"./newUpdatedSmallFarms.jpg": 169,
	"./noImage.jpg": 170,
	"./pinterest.png": 171,
	"./quora.png": 172,
	"./quora2.png": 101,
	"./reddit.png": 173,
	"./sllogo.png": 174,
	"./telegram.png": 175,
	"./telegram1.png": 176,
	"./telegram3.png": 102,
	"./twitter.png": 177,
	"./twitter1.png": 178,
	"./unboxingstartup.png": 179,
	"./unboxingstartups.png": 103,
	"./updatedAgriLands.jpg": 180,
	"./updatedEcoFarms.jpg": 181,
	"./updatedEstateLands.jpg": 182,
	"./updatedSmallFarms.jpg": 183,
	"./whatsAppsyn.png": 184,
	"./whatsapp1.png": 185,
	"./whatsapp2.png": 186,
	"./youtube-svgrepo-com1.png": 104,
	"./youtube8.png": 187,
	"./youtube81.png": 188
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 209;